import {
  FETCH_ALL_COURSES_REQUESTED,
  FETCH_ALL_COURSES_SUCCESSFUL,
  FETCH_ALL_COURSES_FAILED,
  FETCH_SUBCATEGORY_REQUESTED,
  FETCH_SUBCATEGORY_SUCCESSFUL,
  FETCH_SUBCATEGORY_FAILED,
  FETCH_COURSE_BY_ID_REQUESTED,
  FETCH_COURSE_BY_ID_SUCCESSFUL,
  FETCH_COURSE_BY_ID_FAILED,
  FETCH_SIMILAR_COURSES_REQUESTED,
  FETCH_SIMILAR_COURSES_SUCCESSFUL,
  FETCH_SIMILAR_COURSES_FAILED,
  FETCH_CATEGORIES_REQUESTED,
  FETCH_CATEGORIES_SUCCESSFUL,
  FETCH_CATEGORIES_FAILED,
  FETCH_SCHOOL_BUNDLES_REQUESTED,
  FETCH_SCHOOL_BUNDLES_SUCCESSFUL,
  FETCH_SCHOOL_BUNDLES_FAILED,
  FETCH_BUNDLE_BY_ID_REQUESTED,
  FETCH_BUNDLE_BY_ID_SUCCESSFUL,
  FETCH_BUNDLE_BY_ID_FAILED,
  FETCH_COURSE_VOUCHER_REQUESTED,
  FETCH_COURSE_VOUCHER_SUCCESSFUL,
  FETCH_COURSE_VOUCHER_FAILED,
  FETCH_BUNDLE_VOUCHER_REQUESTED,
  FETCH_BUNDLE_VOUCHER_SUCCESSFUL,
  FETCH_BUNDLE_VOUCHER_FAILED,
  REMOVE_VOUCHER,
  APPLY_COURSE_APT_COINS_REQUESTED,
  APPLY_COURSE_APT_COINS_SUCCESSFUL,
  APPLY_COURSE_APT_COINS_FAILED,
  APPLY_BUNDLE_APT_COINS_REQUESTED,
  APPLY_BUNDLE_APT_COINS_SUCCESSFUL,
  APPLY_BUNDLE_APT_COINS_FAILED,
  REMOVE_COINS,
  UPLOAD_SNAPSHOT_REQUESTED,
  UPLOAD_SNAPSHOT_SUCCESSFUL,
  SET_SNAPSHOT_ERROR,
  SHOW_CLASS_KYC_MODAL,
  HIDE_CLASS_KYC_MODAL,
  VERIFY_USER_SELFIE_REQUESTED,
  SET_VERIFICATION_ERROR,
  SET_DARK_MODE,
  GET_PAYMENT_CHANNELS_REQUESTED,
  GET_PAYMENT_CHANNELS_SUCCESSFUL,
  GET_PAYMENT_CHANNELS_FAILED,
  GET_PAYMENT_FEES_REQUESTED,
  GET_PAYMENT_FEES_SUCCESSFUL,
  GET_PAYMENT_FEES_FAILED,
  GET_TRANSACTION_REQUESTED,
  GET_TRANSACTION_SUCCESSFUL,
  GET_TRANSACTION_FAILED,
  FETCH_TRANSACTION_DETAILS_REQUESTED,
  FETCH_TRANSACTION_DETAILS_SUCCESSFUL,
  FETCH_TRANSACTION_DETAILS_FAILED,
  POST_PAYMENT_REQUESTED,
  POST_PAYMENT_SUCCESSFUL,
  POST_PAYMENT_FAILED,
} from "./action-types"

const initialState = {
  courseData: {},
  isLoading: false,
  bundleData: {},
  isLoadingBundles: false,
  categories: [],
  isLoadingCategories: false,
  subcategories: [],
  isLoadingSubcategories: false,
  selectedCourse: {},
  isLoadingSelectedCourse: false,
  selectedBundle: {},
  isLoadingSelectedBundle: false,
  similarCourses: [],
  isLoadingSimilarCourses: false,
  isUploadingSnapshot: false,
  snapshotError: false,
  isVerifyingSelfie: false,
  verificationError: false,
  showClassKYCModal: false,
  errors: {},
  lmsTheme: localStorage.getItem("lms-theme"),
  paymentChannels: [],
  paymentFees: {},
  paymentInstruction: {},
}

const coursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_COURSES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        errors: {},
      }

    case FETCH_ALL_COURSES_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        courseData: action.payload.data,
      }

    case FETCH_ALL_COURSES_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_SUBCATEGORY_REQUESTED:
      return {
        ...state,
        isLoadingSubcategories: true,
        errors: {},
      }

    case FETCH_SUBCATEGORY_SUCCESSFUL:
      return {
        ...state,
        isLoadingSubcategories: false,
        subcategories: action.payload.data,
      }

    case FETCH_SUBCATEGORY_FAILED:
      return {
        ...state,
        isLoadingSubcategories: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_CATEGORIES_REQUESTED:
      return {
        ...state,
        isLoadingCategories: true,
        errors: {},
      }

    case FETCH_CATEGORIES_SUCCESSFUL:
      return {
        ...state,
        isLoadingCategories: false,
        categories: action.payload.data,
      }

    case FETCH_CATEGORIES_FAILED:
      return {
        ...state,
        isLoadingCategories: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_COURSE_BY_ID_REQUESTED:
      return {
        ...state,
        isLoadingSelectedCourse: true,
        errors: {},
      }

    case FETCH_COURSE_BY_ID_SUCCESSFUL:
      return {
        ...state,
        isLoadingSelectedCourse: false,
        selectedCourse: action.payload.data,
      }

    case FETCH_COURSE_BY_ID_FAILED:
      return {
        ...state,
        isLoadingSelectedCourse: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_SIMILAR_COURSES_REQUESTED:
      return {
        ...state,
        isLoadingSimilarCourses: true,
        errors: {},
      }

    case FETCH_SIMILAR_COURSES_SUCCESSFUL:
      return {
        ...state,
        isLoadingSimilarCourses: false,
        similarCourses: action.payload.data,
      }

    case FETCH_SIMILAR_COURSES_FAILED:
      return {
        ...state,
        isLoadingSimilarCourses: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_SCHOOL_BUNDLES_REQUESTED:
      return {
        ...state,
        isLoadingBundles: true,
        errors: {},
      }

    case FETCH_SCHOOL_BUNDLES_SUCCESSFUL:
      return {
        ...state,
        isLoadingBundles: false,
        bundleData: action.payload.data,
      }

    case FETCH_SCHOOL_BUNDLES_FAILED:
      return {
        ...state,
        isLoadingBundles: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_BUNDLE_BY_ID_REQUESTED:
      return {
        ...state,
        isLoadingSelectedBundle: true,
        errors: {},
      }

    case FETCH_BUNDLE_BY_ID_SUCCESSFUL:
      return {
        ...state,
        isLoadingSelectedBundle: false,
        selectedBundle: action.payload.data,
      }

    case FETCH_BUNDLE_BY_ID_FAILED:
      return {
        ...state,
        isLoadingSelectedBundle: false,
        errors: action?.error?.response?.data,
      }

    case FETCH_COURSE_VOUCHER_REQUESTED:
    case FETCH_BUNDLE_VOUCHER_REQUESTED:
      return {
        ...state,
        isLoadingVoucher: true,
        voucherDetails: {},
        errors: {},
      }

    case FETCH_COURSE_VOUCHER_SUCCESSFUL:
    case FETCH_BUNDLE_VOUCHER_SUCCESSFUL:
      return {
        ...state,
        isLoadingVoucher: false,
        voucherDetails: action.payload.data,
        errors: {},
      }

    case FETCH_COURSE_VOUCHER_FAILED:
    case FETCH_BUNDLE_VOUCHER_FAILED:
      return {
        ...state,
        isLoadingVoucher: false,
        voucherDetails: {},
        errors: action?.error?.response?.data,
      }

    case REMOVE_VOUCHER:
      return {
        ...state,
        voucherDetails: {},
        errors: {},
      }

    case APPLY_COURSE_APT_COINS_REQUESTED:
    case APPLY_BUNDLE_APT_COINS_REQUESTED:
      return {
        ...state,
        isLoadingAptCoins: true,
        coinsDiscountDetails: {},
        errors: {},
      }

    case APPLY_COURSE_APT_COINS_SUCCESSFUL:
    case APPLY_BUNDLE_APT_COINS_SUCCESSFUL:
      return {
        ...state,
        isLoadingAptCoins: false,
        coinsDiscountDetails: action.payload.data,
        errors: {},
      }

    case APPLY_COURSE_APT_COINS_FAILED:
    case APPLY_BUNDLE_APT_COINS_FAILED:
      return {
        ...state,
        isLoadingAptCoins: false,
        coinsDiscountDetails: {},
        errors: action?.error?.response?.data,
      }

    case REMOVE_COINS:
      return {
        ...state,
        coinsDiscountDetails: {},
        errors: {},
      }

    case UPLOAD_SNAPSHOT_REQUESTED:
      return {
        ...state,
        isUploadingSnapshot: true,
        snapshotError: false,
      }
    case UPLOAD_SNAPSHOT_SUCCESSFUL:
      return {
        ...state,
        isUploadingSnapshot: false,
        snapshotError: false,
      }

    case SET_SNAPSHOT_ERROR:
      return {
        ...state,
        isUploadingSnapshot: false,
        snapshotError: action.payload,
      }

    case VERIFY_USER_SELFIE_REQUESTED:
      return {
        ...state,
        isVerifyingSelfie: true,
        verificationError: false,
      }

    case SET_VERIFICATION_ERROR:
      return {
        ...state,
        isVerifyingSelfie: false,
        verificationError: action.payload,
      }

    case SHOW_CLASS_KYC_MODAL:
      return {
        ...state,
        showClassKYCModal: true,
      }

    case HIDE_CLASS_KYC_MODAL:
      return {
        ...state,
        showClassKYCModal: false,
      }
    case SET_DARK_MODE:
      localStorage.setItem("lms-theme", action.payload)
      return {
        ...state,
        lmsTheme: action.payload,
      }

    case GET_PAYMENT_CHANNELS_REQUESTED:
      return {
        ...state,
        isLoadingPaymentChannels: true,
        paymentChannels: [],
      }
    case GET_PAYMENT_CHANNELS_SUCCESSFUL:
      return {
        ...state,
        isLoadingPaymentChannels: false,
        paymentChannels: action.payload.data,
      }
    case GET_PAYMENT_CHANNELS_FAILED:
      return {
        ...state,
        isLoadingPaymentChannels: false,
      }

    case GET_PAYMENT_FEES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        paymentFees: {},
      }

    case GET_PAYMENT_FEES_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        paymentFees: action.payload.data,
      }

    case GET_PAYMENT_FEES_FAILED:
      return {
        ...state,
        isLoading: false,
        paymentFees: {},
      }
    case GET_TRANSACTION_REQUESTED:
      return {
        ...state,
        isLoading: true,
        paymentInstruction: {},
      }

    case GET_TRANSACTION_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        paymentInstruction: action?.payload?.data,
      }

    case GET_TRANSACTION_FAILED:
      return {
        ...state,
        isLoading: false,
        paymentInstruction: {},
      }

    case POST_PAYMENT_REQUESTED:
      return {
        ...state,
        isLoading: true,
      }

    case POST_PAYMENT_SUCCESSFUL:
    case POST_PAYMENT_FAILED:
      return {
        ...state,
        isLoading: false,
      }

    case FETCH_TRANSACTION_DETAILS_REQUESTED:
      return {
        ...state,
        isLoadingTransactionDetails: true,
        transactionDetails: {},
        errors: {},
      }

    case FETCH_TRANSACTION_DETAILS_SUCCESSFUL:
      return {
        ...state,
        isLoadingTransactionDetails: false,
        transactionDetails: action.payload.data,
      }

    case FETCH_TRANSACTION_DETAILS_FAILED:
      return {
        ...state,
        isLoadingTransactionDetails: false,
        transactionDetails: {},
        errors: action?.error?.response?.data,
      }

    default:
      return state
  }
}

export default coursesReducer
